import moment from 'moment'

import { dateToString } from 'modules/core/lib/dates'

import { Section } from 'modules/expenses/lib/RouteContextParams'

export const isMyExpensesSection = (section?: Section) => section === 'personal'

const datesToLocalString = (
  startDate: Date | string | undefined,
  endDate: Date | string | undefined
): { from?: string; to?: string } => {
  // The idea is to use the { startDate, endDate } provided by the usePageDateFilters hook (which are simply Dates w/o time component)
  // and set them to the user's local time at the start/end of day respectively, for filtering expenses (in that range) later on

  const startTime = startDate ? moment(startDate).startOf('day') : null
  const endTime = endDate ? moment(endDate).endOf('day') : null

  return {
    from: startTime ? dateToString(startTime, 'backend_datetime') : undefined,
    to: endTime ? dateToString(endTime, 'backend_datetime') : undefined,
  }
}
